import axios from 'axios'

export default {
    namespaced: true,
    actions: {
        fetch({commit, dispatch}, filter) {
            commit('TOGGLE_PRELOADER', true, {root: true})
            return new Promise((resolve) => {
                axios.get(
                    '/api/root/rooms/list',
                    { params: filter }
                ).then(({data}) => {
                    resolve(data.data)
                }).finally(() => {
                    commit('TOGGLE_PRELOADER', false, {root: true})
                }).catch((error) => {
                    dispatch('checkUnauthenticated', error, {root: true})
                })
            })
        },
        fetchFromCheckList({commit, dispatch}, filter) {
            return new Promise((resolve) => {
                axios.get(
                    '/api/director/list-works/get-rooms',
                    { params: filter }
                ).then(({data}) => {
                    commit('SET_ROOMS', data.data)
                    resolve()
                }).catch((error) => {
                    dispatch('checkUnauthenticated', error, {root: true})
                })
            })
        },
        add({dispatch, commit}, data) {
            return new Promise((resolve) => {
                axios.post(
                    '/api/root/rooms/add',
                    data
                ).then(({data}) => {
                    resolve(data.data)
                }).catch((error) => {
                    dispatch('checkUnauthenticated', error, { root: true })
                })
            })
        },
        edit({dispatch, commit}, editedItem) {
            return new Promise((resolve) => {
                axios.put(
                    '/api/root/rooms/edit/' + editedItem.id,
                    editedItem
                ).then(({data}) => {
                    resolve(data.data)
                }).catch((error) => {
                    dispatch('checkUnauthenticated', error, { root: true })
                })
            })
        },
        delete({dispatch}, itemId) {
            return new Promise((resolve) => {
                axios.delete(
                    '/api/root/rooms/dell/' + itemId
                ).then(({data}) => {
                    resolve(data.data)
                }).catch((error) => {
                    dispatch('checkUnauthenticated', error, { root: true })
                })
            })
        },
    }
}

